import { post } from '@/services/http';

export class InventoryLocationSettingModel {
  public id: number;
  public locationId: string;
  public strategy: string;
  public safetyStockDays: number;
  public targetStockDays: number;
  public minDays: number;
  public maxDays: number;
  public minQuantity: number | undefined;
  public maxQuantity: number | undefined;
  public createdAt: string;
  public updatedAt: string;
  // Hold the original values for change tracking
  public originalStrategy: string;
  public originalSafetyStockDays: number;
  public originalTargetStockDays: number;
  public originalMinDays: number;
  public originalMaxDays: number;
  public originalMinQuantity: number | undefined;
  public originalMaxQuantity: number | undefined;

  constructor(data: any = {}) {
    this.id = data.id;
    this.locationId = data.location_id ? String(data.location_id) : (data.locationId ? String(data.locationId) : '');
    this.strategy = data.strategy || 'FORECAST';
    this.safetyStockDays = data.safety_stock_days ?? data.safetyStockDays;
    this.targetStockDays = data.target_stock_days ?? data.targetStockDays;
    this.minDays = data.min_days ?? data.minDays;
    this.maxDays = data.max_days ?? data.maxDays;
    this.minQuantity = data.min_quantity ?? data.minQuantity;
    this.maxQuantity = data.max_quantity ?? data.maxQuantity;
    this.createdAt = data.created_at ?? data.createdAt;
    this.updatedAt = data.updated_at ?? data.updatedAt;

    this.originalStrategy = this.strategy;
    this.originalSafetyStockDays = this.safetyStockDays;
    this.originalTargetStockDays = this.targetStockDays;
    this.originalMinDays = this.minDays;
    this.originalMaxDays = this.maxDays;
    this.originalMinQuantity = this.minQuantity;
    this.originalMaxQuantity = this.maxQuantity;
  }

  public get isDirty(): boolean {
    return this.strategy !== this.originalStrategy ||
           this.safetyStockDays !== this.originalSafetyStockDays ||
           this.targetStockDays !== this.originalTargetStockDays ||
           this.minDays !== this.originalMinDays ||
           this.maxDays !== this.originalMaxDays ||
           this.minQuantity !== this.originalMinQuantity ||
           this.maxQuantity !== this.originalMaxQuantity;
  }

  public async save() {
    // Validate min/max quantity constraints before saving
    if (typeof this.minQuantity === 'number' && typeof this.maxQuantity === 'number') {
      if (this.minQuantity >= this.maxQuantity) {
        throw new Error('Minimum quantity must be less than maximum quantity');
      }
    }

    console.log('Saving location setting:', this.toJSON());
    const payload = {
      settings: [this.toJSON()],
    };
    const response: any = await post('/inventory-location-settings', payload);
    return response;
  }

  public toJSON() {
    const data: any = {
      location_id: this.locationId,
      strategy: this.strategy,
      safety_stock_days: this.safetyStockDays,
      target_stock_days: this.targetStockDays,
      min_days: this.minDays,
      max_days: this.maxDays,
      min_quantity: this.minQuantity,
      max_quantity: this.maxQuantity,
    };
    if (this.id) {
      data.id = this.id;
    }
    return data;
  }
}
